import { IPValidationResult } from "../types/vm.type";
import { Regex } from "./keys";

export class IPValidator {

    static isValidIPv4(ip: string): boolean {

        const ipv4Regex = new RegExp(Regex.ipv4);
        
        if (!ipv4Regex.test(ip)) {
            return false;
        }

        if (ip.startsWith("127.")) {
            return false;
        }
        
        return true;
    }

    static isValidCIDR(cidr: string): boolean {
        const cidrRegex = new RegExp(Regex.cidrBlock);
        return cidrRegex.test(cidr);
    };

    static validateAllowedIPs(allowedIPs: string): IPValidationResult {

        if (!allowedIPs.trim()) {
            return { valid: false, errors: ["Input cannot be empty"], validIPs: [] };
        };

        if (new RegExp(Regex.multipleSpaces).test(allowedIPs) || new RegExp(Regex.missingComma).test(allowedIPs)) {
            return { valid: false, errors: ["Please separate IPs or CIDR blocks using commas"], validIPs: [] };
        };

        const errors: string[] = [];

        const ipList = allowedIPs.split(",")
            .map(ip => ip.trim())
            .filter(ip => ip.length > 0);

        if (ipList.length === 0) {
            return { valid: false, errors: ["No valid IPs or CIDR blocks provided"], validIPs: [] };
        };

        ipList.forEach((ip) => {
            if (!this.isValidIPv4(ip)) {
                errors.push(`Invalid IPv4 format: ${ip}`);
            };

            if (ip.split('.').length != 4)
            {
                errors.push(`Invalid IPv4 format: ${ip}`);
            };

            if (ip === '127.0.0.1') {
                errors.push(`Loopback address cannot be whitelisted: ${ip}`);
            };

        });

        const uniqueIPs = new Set(ipList);

        if (uniqueIPs.size !== ipList.length) {
            errors.push("Duplicate IPs or CIDR blocks are not allowed");
        };

        return { valid: errors.length === 0, errors, validIPs: Array.from(uniqueIPs) };

    }

}
